import React, { useState } from 'react'
import CashImg from "../../Assets/Images/cashbox_6.1.png"
import CashImg2 from "../../Assets/Images/cashbox_9.1.png"
import { Modal } from 'antd';
import ClearIcon from '@mui/icons-material/Clear';
function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <section id='about-company' className='bg-[#FF9C4E] py-20'>
      <div className='container px-5 mx-auto flex flex-col lg:flex-row justify-center items-center space-y-5 lg:space-y-0 lg:space-x-20'>
        <img data-aos="fade-down" src={CashImg} width={540} height={471} alt='Img about cashbox cash aparat' />
        <div data-aos="zoom-in-up" className='max-w-[452px] mx-auto'>
          <h2 className='text-[30px] sm:text-[40px] font-bold text-white mb-2'>О КОМПАНИИ</h2>
          <p className='text-white text-[14px] mb-5 sm:text-[18px]'>Основная цель компании – увеличить прибыль своих клиентов путем предоставления современных сервисов и новых возможностей. «CASHBOX» – учет товара, контроль стоимости и наценки, генерирования отчетов (административных и бухгалтерских), интеграция с 1С, контроль работы кассиров. «CASHBOX» – онлайн касса, в основе формирования и развития цифровой экономики в Республике Узбекистан.</p>
          <button onClick={showModal} className='bg-[#00C9DB] w-[140px] duration-200 py-1.5 border-2 hover:bg-transparent hover:text-[#00C9DB] border-[#00C9DB] rounded-[20px] text-center text-white font-semibold'>ДАЛЕЕ</button>
        </div>
      </div>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div className='w-[320px] sm:w-[400px] lg:w-[800px] mx-auto relative p-10 rounded-md bg-[#2F2C3D]'>
          <div className='py-4'>
            <button onClick={handleCancel} className='absolute right-4 top-3 text-white'>
              <ClearIcon style={{ "inlineSize": "35px", "blockSize": "35px" }} />
            </button>
          </div>
          <div className="flex flex-col lg:flex-row justify-between">
            <img className='w-[227px] mx-auto lg:mx-0 mb-5 lg:mb-0 h-[543px]' src={CashImg2} width={227} height={543} alt='Img about cashbox cash aparat' />
            <div className='max-w-[350px]'>
              <h2 className='text-white leading-7 text-[25px] lg:text-[35px] font-bold'>О КОМПАНИИ</h2>
              <span className='inline-block mt-1 h-[2px] w-[80px] rounded-md bg-[#00C9DB]'></span>
              <p className='text-white mt-3 text-[13px] lg:text-[18px]'>Общество с ограниченной ответственностью «TSS CENTER» была создана в целях участия в исполнении Постановления Президента Республики Узбекистан №3300 от 29 сентября 2017 года «О мерах по дальнейшему совершенствованию применения контрольно-кассовых машин с фискальной памятью». Основное направление деятельности –техническое обслуживание и ремонт онлайн контрольно кассовых машин по Республике Узбекистан.</p>
            </div>
          </div>
        </div>
      </Modal>
    </section>
  )
}

export default About